import { render, staticRenderFns } from "./TextEditorAudioDialog.vue?vue&type=template&id=bd2822d4"
import script from "./TextEditorAudioDialog.vue?vue&type=script&lang=ts"
export * from "./TextEditorAudioDialog.vue?vue&type=script&lang=ts"
import style0 from "./TextEditorAudioDialog.vue?vue&type=style&index=0&id=bd2822d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports